import { getPhotoSdk } from "./photo"

export const getDocumentsSdk = () => {
  const sdk = getPhotoSdk()
  const documents = sdk.documentWalletService

  return documents
}